import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { SavedBerichtsVorlagenFiltersComponent } from '.';
import { BerichtsVorlagenServiceModule } from '..';

@NgModule({
  imports: [LIB_CommonModule, BerichtsVorlagenServiceModule],
  declarations: [SavedBerichtsVorlagenFiltersComponent],
  exports: [SavedBerichtsVorlagenFiltersComponent],
})
export class SavedBerichtsVorlagenFiltersComponentModule {}
